import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';

interface Props {
  headline?: React.ReactElement;
  className?: string;
  headlineStyles?: string;
}

/**
 * Inspired by Material UI Paper this is a layout element to render content into a box.
 * Box by default has shadowy effect, so this component can be used to distruingish and highlight
 * certain information in the UI.
 */
export const Paper: React.FC<React.PropsWithChildren<Props>> = ({
  headline,
  children,
  className,
  headlineStyles,
}) => {
  return (
    <Container className={className}>
      {!!headline && (
        <HeadlineContainer className={headlineStyles}>
          {headline}
        </HeadlineContainer>
      )}
      {children}
    </Container>
  );
};

const Container = styled.div`
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 4%), 0 10px 15px 0 rgb(0 0 0 / 4%);
  border: solid 1px ${COLORS.Grey3};
  background-color: ${COLORS.White};
  padding: 24px;
`;

const HeadlineContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
